<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col cols="6" class="py-0">
                    <v-col cols="8" class="py-0 my-0">
                        <client-selector :addAllOption="false" class="py-0 my-0 " ref="clientSelector" @getClients="v => items.clients = v" :is_national="2"></client-selector>  
                    </v-col>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="6" align="end" class="py-0">                    
                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" @click="show_export_options = true" v-if="show_export_options == false">
                        {{ $t('balance_pallet_report.export') }}
                    </v-btn>

                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="exportDataPdf">
                        PDF
                    </v-btn>
                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="exportDataExcel">
                        Excel
                    </v-btn>

                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="show_export_options = false;">
                        <v-icon small class="px-0">
                            keyboard_arrow_left
                        </v-icon>
                    </v-btn>
                
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="generate">
                        {{ $t('balance_pallet_report.generate') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import FileSaver from 'file-saver';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('balance_pallet_report.id_income'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.container'), align: "center", value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.income'), align: "center", value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.received_quantity'), align: "center", value: 'received_quantity', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.available_quantity'), align: "center", value: 'available_quantity', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.received_weight'), align: "center", value: 'received_weight', class: 'text-uppercase' },
                { text: this.$t('balance_pallet_report.available_weight'), align: "center", value: 'available_weight', class: 'text-uppercase' },
            ];
        },
        client: function(){
            return this.$store.state.clientId
        },
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            menu2: false,
            menu3: false,
            showExport: false,
            show_export_options: false,
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.balance_pallet";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){
            this.props.items = [];
        },
        generate(){
            this.props.items =[];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'reports/balancePerPallet?warehouse=' + this.$store.state.warehouseId + '&client=' + this.$store.state.clientId, {headers: {Authorization: lsToken}})
            .then((response) => {
                this.props.items = response.data.data;
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        exportDataExcel(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'reports/balancePerPalletExport?warehouse=' + this.$store.state.warehouseId + '&client=' + this.$store.state.clientId, {headers: {Authorization: lsToken}, responseType:'blob'})
            .then(response => {
                this.$store.state.loaderProps.visible = false; 
                FileSaver.saveAs(response.data, 'Existencias.xlsx');
                this.show_export_options = false;
            })
            .catch((error) => {
                let message = "";
                if(error.response.status == 404) message = this.$t("yego_reports.errors.not_found");
                else message = this.$t("yego_reports.errors.unexpected");
                this.$store.state.loaderProps.visible = false;
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: message
                };
            })
        },
        exportDataPdf(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'reports/balance_palletPdf?warehouse=' + this.$store.state.warehouseId + '&client=' + this.$store.state.clientId, {headers: {Authorization: lsToken}, responseType:'blob'})
            .then(response => {
                this.$store.state.loaderProps.visible = false; 
                FileSaver.saveAs(response.data, 'Existencias.pdf');
                this.show_export_options = false;
            })
            .catch(() => {
                this.$store.state.loaderProps.visible = false;
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            })
        }
    }
}
</script>

<style>
</style>